import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Row } from 'reactstrap';
import './profile.scss';
export interface IModalDeleteGroupProps {
  showModalConfirm: boolean;
  invokeAgree: Function;
}

class ModalDeleteGroup extends React.Component<IModalDeleteGroupProps> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Modal isOpen={this.props.showModalConfirm} centered={window.location === window.parent.location}>
          <ModalHeader>
            <h3 className="font-weight-bold">Thông Báo</h3>
          </ModalHeader>
          <ModalBody className="padding-modal-body">
            <Row style={{ padding: '20px' }}>
              <h5>
                <span>Bạn không thể xoá vì tài khoản chỉ còn một phương thức xác thực!</span>
              </h5>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="btn-register" onClick={this.props.invokeAgree}>
              OK
            </Button>{' '}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ModalDeleteGroup;
